$( ->

  # DESKTOP JOBS INDEX MORE/LESS FILTER TOGGLE BUTTON TITLE

  $(document).on 'click', '#toggle-jobs-filters', ->
    if $(this).hasClass('collapsed')
      $(this).text('More Filters')
    else
      $(this).text('Less Filters')



  # DESKTOP JOBS INDEX SCROLLABLE APP DETAILS

  scrollable_target = '.scrollable-item-container .scrollable.manual'
  scrollable_init = ->
    scrollable = $(this)
    scrollable_width = 0
    scrollable.find('.scroll-step').each ->
      scrollable_width += $(this).width() +
        parseInt($(this).css('margin-left').replace('px','')) +
        parseInt($(this).css('margin-right').replace('px','')) +
        parseInt($(this).css('padding-left').replace('px','')) +
        parseInt($(this).css('padding-right').replace('px',''))
    scrollable.width(scrollable_width + 50)

  $(document).on 'dom_updated', '.lazy', ->
    $(this).find(scrollable_target).each scrollable_init
    $(this).find('.has-scroll-buttons').cpScrollButtons()
  $(scrollable_target).each scrollable_init



  # MOBILE JOBS INDEX 'VIEW APPLICANTS' BUTTON (EXPANDS OUT APP COUNT BUTTONS WHEN CLICKED)

  $(document).on 'click', '.mobile-job-action-button[data-action="view-apps"]', ->
    $(this).hide()
    $(this).closest('.action-buttons').find('.mobile-job-action-button.hidden').each ->
      $(this).removeClass('hidden')
)
